export default {
  state: {
    platformTours: null
  },
  mutations: {
    setPlatformTour(state, payload) {
      localStorage.setItem("idt-platform-tours", JSON.stringify(payload))
      state.platformTours = payload
    }
  },
  actions: {
    getPlatformTour({commit}) {
      this.commit("setPlatformTour", JSON.parse(localStorage.getItem("idt-platform-tours")))
    },
    createLocalStorageTour({commit}) {
      this.commit("setPlatformTour", {
        firstAccess: false,
        "personal-data": false,
        organization: false,
        profile: false,
        "organization-documents": false,
        "program-documents": false,
        partners: false,
        "bank-account": false
      })
    }
  }
}
